export function getCardBrandColor(brand: string): { dot: string; text: string } {
  switch (brand) {
    case 'Visa Debit':
      return { dot: 'bg-sky-500', text: 'text-sky-600' };
    case 'Visa Credit Classic':
      return { dot: 'bg-blue-500', text: 'text-blue-600' };
    case 'Visa Credit Gold':
      return { dot: 'bg-amber-500', text: 'text-amber-600' };
    case 'Master Debit':
      return { dot: 'bg-teal-500', text: 'text-teal-600' };
    case 'Master Credit Classic':
      return { dot: 'bg-orange-500', text: 'text-orange-600' };
    case 'Master Credit Gold':
      return { dot: 'bg-rose-500', text: 'text-rose-600' };
    case 'CBM Credit':
      return { dot: 'bg-emerald-500', text: 'text-emerald-800' };
    default:
      return { dot: 'bg-slate-400', text: 'text-white' };
  }
}
